<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules" label-width="120px">
      <el-row>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_name')||'姓名'" prop="contactName">
            <el-input v-model="formData.contactName" maxlength="50"  size="small"
                      :placeholder="$l('conact_form_label_name')||'请输入联系人姓名'" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_position')||'职位'" prop="contactJob">
            <el-input v-model="formData.contactJob" maxlength="50"  size="small" :placeholder="$l('conact_form_label_position')||'请输入联系人职位'" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_mobile_phone')||'移动电话'" prop="contactMobile">
            <el-input v-model="formData.contactMobile" maxlength="50" size="small" :placeholder="$l('conact_form_label_mobile_phone')||'请输入移动电话'" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_office_phone')||'办公电话'">
            <el-input v-model="formData.contactPhone" maxlength="50" size="small" :placeholder="$l('conact_form_label_office_phone')||'请输入办公电话'" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_email')||'电子邮件'">
            <el-input v-model="formData.contactEmail" maxlength="50" size="small" :placeholder="$l('conact_form_label_email')||'请输入邮件地址'" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_default_contact')||'默认联系人'" prop="contactDefaultFlag">
            <el-radio-group style="width: 100%;" size="small" v-model="formData.contactDefaultFlag">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_card_front')||'名片-正面'" prop="contactNameCardUrl1">
            <el-upload
              style="width: 100%;"
              class="contacts-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :on-success="handleAvatarSuccess1">
              <img v-if="formData.contactNameCardUrl1" :src="formData.contactNameCardUrl1" class="contactsEvent">
              <i v-else class="el-icon-plus contactsEvent-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 12}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('conact_form_label_card_back')||'名片-背面'" prop="contactNameCardUrl2">
            <el-upload
              style="width: 100%;"
              class="contacts-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :on-success="handleAvatarSuccess2">
              <img v-if="formData.contactNameCardUrl2" :src="formData.contactNameCardUrl2" class="contactsEvent">
              <i v-else class="el-icon-plus contactsEvent-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="{span: 24}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
          <el-form-item :label="$l('conact_form_label_remarks')||'备注信息'">
            <el-input type="textarea" :rows="3" v-model="formData.contactMemo" clearable size="small" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right;">
          <el-button size="small" @click="back">{{$l('form_btn_return')||'返回'}}</el-button>
          <el-button size="small" type="primary" @click="save">{{$l('form_btn_save')||'保存'}}</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import util from '@/libs/util'
export default {
  data () {
    return {
      formData: {
        contactName: ''
      }, // 数据
      fileData: { // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles'
      },
      fileHeaders: { // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken()
      },
      rules: {
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactJob: [
          { required: true, message: '请输入联系人职位', trigger: 'blur' }
        ],
        contactMobile: [
          { required: true, message: '请输入联系人移动电话', trigger: 'blur' }
        ],
        contactDefaultFlag: [
          { required: true, message: '请选择是否为默认联系人', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (formData) {
      this.formData = formData
    },
    save () {
      console.log(this.formData.type)
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.type === 'add') {
            this.$api.scmInfoContactsAddApi(this.formData)
              .then(() => {
                this.$message({
                  showClose: true,
                  message: '保存成功',
                  type: 'success'
                })
                this.$emit('getData')
                this.$emit('back')
              })
          } else if (this.formData.type === 'update') {
            this.$api.scmInfoContactsUpdateApi(this.formData)
              .then(() => {
                this.$message({
                  showClose: true,
                  message: '保存成功',
                  type: 'success'
                })
                this.$emit('getData')
                this.$emit('back')
              })
          }
        } else {
          return false
        }
      })
    },
    // 文件上传
    handleAvatarSuccess1 (res, file) {
      if (res.status === 200) {
        this.formData.contactNameCardCode1 = res.body.fileId
        this.formData.contactNameCardUrl1 = res.body.url
      }
    },
    // 文件上传
    handleAvatarSuccess2 (res, file) {
      if (res.status === 200) {
        this.formData.contactNameCardCode2 = res.body.fileId
        this.formData.contactNameCardUrl2 = res.body.url
      }
    },
    back () {
      this.$emit('back')
    }
  }
}
</script>
 <style>
   td{
     padding: 6px 0 !important;
   }
   .contacts-uploader {
     border: 1px dashed #d9d9d9;
     width: 270px !important;
     height: 150px;
     line-height: 150px !important;
     text-align: center;
   }
   .contactsEvent-uploader-icon {
     font-size: 28px;
     color: #8c939d;
     width: 270px !important;
     height: 150px;
     line-height: 150px !important;
     text-align: center;
   }
   .contactsEvent {
     width: 270px !important;
     height: 150px;
     display: block;
   }
 </style>
